/* Includes js theme idep */
import './components/body';
import './page/comunicacion-divulgacion/sliders';
import './page/comunicacion-divulgacion/slider-podcast';
import './page/comunicacion-divulgacion/slider-publications';
import './page/comunicacion-divulgacion/slider-video';
import './page/para-profes/convocatoria-calendar'
import './components/external-link-logos';
import './components/font-zoom';
import './components/high-contrast';
import './components/main-menu';
import './components/main-slider';
import './components/region-language'
import './components/relief-center'
import './test/test'
import './test/aid'
import './test/res'
